import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { environment } from "environments/environment";
import { BehaviorSubject } from "rxjs";
import { finalize } from "rxjs/operators";

@Injectable({
  providedIn: "root",
})
export class InquiryService {
  private _isLoading$ = new BehaviorSubject<boolean>(false);
  private _isLoadingTable$ = new BehaviorSubject<boolean>(false);
  private _badgeCount$ = new BehaviorSubject<number>(0);

  private apiUrl = environment.apiUrl;

  constructor(private http: HttpClient) { }

  get isLoading$() {
    return this._isLoading$.asObservable();
  }

  get isLoadingTable$() {
    return this._isLoadingTable$.asObservable();
  }

  get badgeCount$() {
    return this._badgeCount$.asObservable();
  }

  getInquiryList(params = {}) {
    this._isLoadingTable$.next(true);
    return this.http.post(`${this.apiUrl}/inquiry-list`, params).pipe(
      finalize(() => {
        this._isLoadingTable$.next(false);
      })
    );
  }

  setStatus(id, body) {
    this._isLoading$.next(true);
    return this.http
      .put(`${this.apiUrl}/inquiry-list/change-status/${id}`, body)
      .pipe(
        finalize(() => {
          this._isLoading$.next(false);
          this.getBadgeCount();
        })
      );
  }

  getBadgeCount() {
    this._isLoading$.next(true);
    return this.http
      .get(`${this.apiUrl}/inquiry-list/badge/count`)
      .pipe(
        finalize(() => {
          this._isLoading$.next(false);
        }),
      ).subscribe((response: any) => {
        this._badgeCount$.next(response.result);
      });
  }
}
